import SideMenuOptionsStandard from './SideMenuOptionsStandard';

export default SideMenuOptionsStandard;
